import { createContext } from "react";

import type {
  Filter,
  CatalogSearchType,
  ProductSortField,
  ProductSortDirection,
  IngredientFilter,
  SupplementTypeFilter,
  CategoryFilter,
  Brand,
  ConditionFilter,
  IngredientFilterV2,
} from "@shared/components/CatalogSearch/CatalogSearch";

interface CatalogSearchData {
  activeFilters: Filter[];
  setActiveFilters: (activeFilters: Filter[]) => void;
  activeBrands: Brand[];
  setActiveBrands: (activeBrands: Brand[]) => void;
  activeIngredients: IngredientFilter[] | IngredientFilterV2[];
  setActiveIngredients: (activeIngredients: IngredientFilter[] | IngredientFilterV2[]) => void;
  excludedIngredients: IngredientFilter[] | IngredientFilterV2[];
  setExcludedIngredients: (excludedIngredients: IngredientFilter[] | IngredientFilterV2[]) => void;
  activeSupplementTypes: SupplementTypeFilter[];
  setActiveSupplementTypes: (activeSupplementTypes: SupplementTypeFilter[]) => void;
  activeConditions?: ConditionFilter[];
  setActiveConditions?: (activeConditions: ConditionFilter[]) => void;
  activeCategories?: CategoryFilter[];
  setActiveCategories?: (activeCategories: CategoryFilter[]) => void;
  searchQuery: string;
  setSearchQuery: (queryText: string, queryId?: string) => void;
  removeActiveFilter: (filterToRemove: Filter) => void;
  activeSearchType: CatalogSearchType;
  setActiveSearchType: (searchFilter: CatalogSearchType) => void;
  sortDirection: ProductSortDirection;
  sortField: ProductSortField;
  setSort: (sortField: ProductSortField, sortDirection: ProductSortDirection) => void;
  isOnlyShowFavorites?: boolean;
  setIsOnlyShowFavorites?: (value: boolean) => void;
  isOnlyShowInStock?: boolean;
  setIsOnlyShowInStock?: (value: boolean) => void;
  isGridView: boolean;
  setGridView: (value: boolean) => void;
  onlyIngredient: boolean;
  setOnlyIngredient: (value: boolean, areIngredientsExcluded?: boolean) => void;
  typeaheadSelectionId: string;
}

const CatalogSearchContext = createContext<CatalogSearchData>(null);

export type { CatalogSearchData };
export { CatalogSearchContext };
